import { useEffect, useMemo, useState } from "react";
import api from "../../api";
import "./About.css";

export default function About() {
  const [projectCount, setProjectCount] = useState(0);

  useEffect(() => {
    let isMounted = true;

    api
      .get("/posts")
      .then((res) => {
        if (!isMounted || !Array.isArray(res.data)) return;
        setProjectCount(res.data.length);
      })
      .catch(() => {
        if (isMounted) {
          setProjectCount(0);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  const stats = useMemo(
    () => [
      { value: `${projectCount}`, label: "Projets" },
      { value: "2", label: "Certifications" },
      { value: "3", label: "Annees d'experience" },
    ],
    [projectCount]
  );

  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="section-heading reveal-up">
          <span className="eyebrow">Presentation</span>
          <h2 className="section-title">A propos de moi</h2>
          <p className="section-subtitle">
            Donner vie aux idees a travers des experiences digitales nettes,
            utiles et memorables.
          </p>
        </div>

        <div className="about-layout">
          <div className="about-copy reveal-left">
            <span className="about-hello">Bonjour, je suis</span>
            <h3 className="about-name">Augustin</h3>

            <p className="about-text">
              Etudiant en informatique oriente full-stack, je construis des
              interfaces modernes et des experiences web credibles, avec un
              vrai soin porte a la lisibilite, a la performance et au detail.
            </p>

            <div className="about-actions">
              <a href="#portfolio" className="btn-dark">
                Voir les projets
              </a>
              <a href="#contact" className="btn-outline-dark">
                Me contacter
              </a>
            </div>
          </div>

          <div className="about-visual reveal-right">
            <div className="about-avatar glass-panel">
              <div className="about-avatar-ring" aria-hidden="true" />
              <div className="about-avatar-glow" aria-hidden="true" />
              <div className="about-avatar-core">
                <img src="/favicon.svg" alt="Logo augdev" className="about-avatar-logo" />
              </div>
            </div>
          </div>
        </div>

        <div className="about-stats">
          {stats.map((stat, index) => (
            <div
              key={stat.label}
              className="stat-card reveal-up"
              style={{ animationDelay: `${index * 110}ms` }}
            >
              <h3>{stat.value}</h3>
              <p>{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
